// Generate random color for avatar background
export const getRandomColor = (): string => {
  const colors = [
    "#FF5733", "#33FF57", "#3357FF",
    "#FF33A6", "#FF8C33", "#33FFF5"
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

// Get initials from name
export const getInitials = (name: string): string => {
  const words = name.trim().split(" ");
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
};
